module.exports = __webpack_public_path__ + "img/btn_return.d430fb8e.png";